module.exports = __webpack_public_path__ + "static/img/channel4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/channel4.png
// module id = 546
// module chunks = 0